module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2025_fr-146c4576d96c37574380578f72c5c67c.jpg";